import React from 'react'
import { Backdrop, Base, InlineBlock, Popover } from 'reakit'

const Trigger = Base.extend`
  background-color: transparent;
  outline: none;
`

const Content = Popover.extend`
  display: flex;
  justify-content: center;
  min-width: 150px;
  border: none;
  box-shadow: ${props => props.theme.shadows[1]};
`

const Arrow = Popover.Arrow.extend`
  &&& {
    :after {
      border: solid .5px #e2e2e2;
    }
  }
`

const Component = ({trigger, content}) =>
  <Popover.Container>
    {popover => (
      <InlineBlock relative>
        <Backdrop background='transparent' as={Popover.Hide} {...popover} />
        <Trigger as={Popover.Toggle} {...popover}>
          {trigger}
        </Trigger>
        <Content {...popover}>
          <Arrow />
          {content}
        </Content>
      </InlineBlock>
    )}
  </Popover.Container>

export default Component


// WEBPACK FOOTER //
// ./src/components/Popover.js